import React from 'react';
import EducatorStudentToggle from './EducatorStudentToggle';
import HomeGreeting from './HomeGreeting';
import HomeSpacesSection from './HomeSpacesSection';
import { Icons } from '@ublend-npm/aulaui-core';
import ManageWidget from './widgets/manageWidget';
import MessagesWidget from './widgets/messagesWidget';

const widgetsLibrary = [
  {
    id: 'home-greeting-widget',
    component: <HomeGreeting />,
    icon: <Icons.AssignmentOutlined />,
    title: 'Greeting',
    size: { lg: 12, md: 12, xs: 12 },
  },
  {
    id: 'home-space-widget',
    component: (
      <>
        <EducatorStudentToggle />
        <HomeSpacesSection />
      </>
    ),
    icon: <Icons.AssignmentOutlined />,
    title: 'Space',
    size: { lg: 12, md: 12, xs: 12 },
  },
  {
    id: 'home-messages-widget',
    component: <MessagesWidget />,
    icon: <Icons.AssignmentOutlined />,
    title: 'Messages Widgets',
    size: { lg: 4, md: 6, xs: 12 },
  },
  {
    id: 'home-manage-widget',
    component: <ManageWidget />,
    icon: <Icons.AssignmentOutlined />,
    title: 'Manage Widgets',
    size: { lg: 4, md: 6, xs: 12 },
  },
];

export default widgetsLibrary;
